import { InputBaseClassKey } from '@material-ui/core/InputBase';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

export const THDInputBaseStyles: Partial<
  Record<InputBaseClassKey, CSSProperties>
> = {
  root: {
    fontSize: '1.4rem',
  },
  input: {
    '&::placeholder': {
      color: '#7A7978',
    },
  },
};
